import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action, computed } from "@ember/object"
import { inject as service } from "@ember/service"
import { A, pipe } from "@mobily/ts-belt"
import type { CardStack } from "@shared/models/card-stack"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import belongsTo from "cc-frontend/helpers/belongs-to"
import findDocument from "cc-frontend/helpers/find-document"
import findMany from "cc-frontend/helpers/find-many"
import hasManyCollectively from "cc-frontend/helpers/has-many-collectively"
import { isCachedMembershipActiveInclAncestors } from "cc-frontend/utils/group"
import { isNil } from "lodash-es"
import ENV from "../../../config/environment"
import styles from "./choose-from-gallery.module.css"

@tagName("")
export default class ChooseFromGallery extends Component {
  readonly styles = styles

  // args
  planbook!: Planbook
  lesson!: CardStack
  courses!: Array<Course>
  goToNextStep!: Function
  createTemplate!: Function
  chooseTemplate!: Function

  // state
  isAtEnd = false
  isAtBeginning = true
  cardStackId: string | null = null
  // @ts-ignore It really exists
  ccTemplateGroupId = ENV.CC_TEMPLATE_GROUP_ID
  ccTemplateGroupIds = [
    // This is a very minimal one
    // @ts-ignore It really exists
    ENV.CC_TEMPLATE_GROUP_ID,
    // ENV.CC_TEMPLATE_GROUP_ID_1,
    // ENV.CC_TEMPLATE_GROUP_ID_2,
    // ENV.CC_TEMPLATE_GROUP_ID_3,
  ]
  // ccTemplateGroupIds = [
  //   ENV.CC_TEMPLATE_GROUP_ID_1,
  //   ENV.CC_TEMPLATE_GROUP_ID_2,
  //   ENV.CC_TEMPLATE_GROUP_ID_3,
  // ]
  selectedGroupId = ENV.CC_TEMPLATE_GROUP_ID_1
  hideCreateTemplate: boolean = false

  // services
  @service("ember-store") store

  // relationships
  @findDocument("ccTemplateGroupId", "group") ccGroup
  @belongsTo("planbook", "owner") planbookOwner

  @computed("planbookOwner.content.attributes.cachedMemberships.length")
  get planbookOwnerGroupIds() {
    if (isNil(this.planbookOwner.content)) return []
    return pipe(
      this.planbookOwner.content.attributes.cachedMemberships,
      A.filter(isCachedMembershipActiveInclAncestors),
      A.map((membership) => membership.groupId),
      A.uniq
    )
  }

  @findMany("ccTemplateGroupIds", "group") ccTemplateGroups
  @findMany("planbookOwnerGroupIds", "group") planbookOwnerGroups
  @hasManyCollectively("planbook", "card-stack", "cardStackTemplates") planbookTemplates

  // computed props
  @computed("selectedGroupId")
  get showingAllTemplates() {
    return this.get("selectedGroupId") === "ALL_TEMPLATES"
  }

  // actions

  @action
  onScroll(e) {
    let scrollLeft = e.target.scrollLeft
    let scrollWidth = e.target.scrollWidth
    let width = e.target.offsetWidth
    this.set("isAtBeginning", scrollLeft === 0)
    this.set("isAtEnd", scrollLeft + width === scrollWidth)
  }

  @action
  scroll(direction: "LEFT" | "RIGHT") {
    let $el = $("#templates-scrolling-list-wrapper")
    if ($el === undefined) return
    let $boxEl = $(".js-template-box").first()
    let width = $boxEl.width() || 0
    let container = $el[0]
    container.scrollBy({ left: direction === "LEFT" ? -width : width, behavior: "smooth" })
  }

  @action
  selectTemplateGroup(id) {
    this.set("selectedGroupId", id)
  }
}
